import { type AnimationControlValue, AnimationRadioGroup } from './AnimationRadioGroup';
import { durationOptions, type AnimationDuration } from './animationControlOptions';

type AnimationDurationControlProps = {
    value?: AnimationControlValue<AnimationDuration>;
    defaultValue?: AnimationControlValue<AnimationDuration>;
    onChange?: (value: AnimationControlValue<AnimationDuration>) => void;
};

const AnimationDurationControl = (props: AnimationDurationControlProps) => (
    <AnimationRadioGroup
        name='duration'
        options={durationOptions}
        className='display-flex flex-wrap justify-content-center'
        {...props}
    />
);

export default AnimationDurationControl;
